import { render, staticRenderFns } from "./UserRegionRemoveForm.vue?vue&type=template&id=72ff7dfb&"
import script from "./UserRegionRemoveForm.vue?vue&type=script&lang=js&"
export * from "./UserRegionRemoveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports